import React, { FC, useEffect, useRef, useState } from 'react';
import { Wizard, useWizard } from 'react-use-wizard';
import { motion, AnimatePresence } from "framer-motion";

import * as BtForm from 'react-bootstrap/Form';

import { Formik, Field, Form, FormikProps } from 'formik'
import * as yup from 'yup';

import { Tabs, Tab } from 'react-bootstrap';

// React - Bootstrap
import { Modal } from 'react-bootstrap';

//Utils
import axiosInstance from '../Utils/axios_manager';

const { countries } = require('country-data-list');

console.log(countries);

// Example: show the active step in the header /react-payment
const Header = () => <img className='App-logo' 
src="/react-payment/assets/img/onboarding-preview-form-image.min.jpg" alt="" />;

// Example: show the "previous" and "next" buttons in the footer /react-payment
const Footer = () => <div style={{ marginTop: '20px' }} ><p>
  <img style={{ width: 30, height: 20, display: 'inline-block' }} src="/react-payment/assets/img/logo.jpg" alt="" /> 
  Association Sainte Marthe
  </p>
</div>;

// Example: Wrap steps in an `<AnimatePresence` from framer-motion 
const Wrapper = () => <div className='wrapper'></div> ;

const numberWithCommas = (x: any) => {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}




interface DonationForm {
//   name: string;
//   email: string;
//   phone: string;
  amount: number | null;
  currency: string;
}

interface DonationMobilePaymentForm {
    customer_name: string; 
    customer_email: string;
    customer_country: string;
    customer_phone_number: string;   
}

interface DonationCardPaymentForm {
    customer_name: string; 
    customer_surname: string;
    customer_email: string;
    customer_phone_number: string;  
    customer_address: string;
    customer_city: string;
    customer_country: string;
    customer_state: string
    customer_zip_code: string; 
}

interface DonationData {
  amount?: number | null;
  currency?: string;
  method?: string;
}

let donationData: DonationData = {};

const Step1 = () => {
  const {
    isLoading,
    isLastStep,
    isFirstStep,
    activeStep,
    stepCount,
    previousStep,
    nextStep,
    goToStep,
    handleStep,
  } = useWizard();

  // This handler is optional
  handleStep(() => {
    // alert('Going to step 2');
  });

  return (
    <div className='wrapper'>
       <h2 className='stepTitle'> Soutenez notre cause </h2>
       <div className="seperator"></div>
       <p className='description' >
        Apportez un plus à l'œuvre de l'association sainte Marthe, faite un geste pour apporter un plus à nos
         malades.
       </p>
       <button onClick={evt => nextStep()} className="give-btn advance-btn" tabIndex={1}>
        Donnez maintenant<i className="fas fa-chevron-right"></i></button>
    </div>
  );
};

const Step2 = () => {
  const {
    isLoading,
    isLastStep,
    isFirstStep,
    activeStep,
    stepCount,
    previousStep,
    nextStep,
    goToStep,
    handleStep,
  } = useWizard();

  const formRef = useRef< FormikProps< DonationForm >>(null);
  // 'XOF', 'XAF', 'CDF', 'GNF', currency
  let [ currencies, setCurrencies ] = useState([ 'XOF'  ]);
  let [ definedAmounts, setDefinedAmounts ] = useState([ 100, 1000, 5000, 10000, 20000, 30000, 50000, null ]);
  const currentAmountInit: any = null;
  let [ currentAmount, setCurrentAmount ] = useState(currentAmountInit);

  // This handler is optional
  handleStep(() => {
    // alert('Going to step 2');
  });

  return (
    <div className='wrapper'>
       <h2 className='stepTitle'> Soutenez notre cause </h2>
       <div className="seperator"></div>
        <br/>
       <Formik
        initialValues={
            { amount: 100, currency: 'XOF' }}
        validationSchema={
            yup.object().shape({
             
                amount: yup
                    .number()
                    .required('Ce champ est obligatoire')
                    .test('checkMinimumAmount', "La somme minimum est de 100 Fcfa", async value =>
                       value < 100 ? false : true
                  ),
                currency: yup
                    .string()
                    .required('Ce champ est obligatoire')
            })
        }
        innerRef={formRef}
        onSubmit={async (
            values 
          ) => {
              donationData = {
                amount: values.amount,
                currency: values.currency
              }; 
             
            nextStep();
                    
                    
          }}>
                {({ dirty, errors, touched, isValid, handleChange, handleBlur, handleSubmit, values }) => (
                    <Form className='pure-form'>
                       <fieldset>
                      <div className="pure-g"> 

                        <div className="pure-u-4-5 pure-u-md-4-5 ">

                          <div className='pure-g'>
                              <label className="pure-u-1-5" htmlFor=""> {'Montant'} 
                              <span style={{ color: 'red' }}> *</span>  </label>
                              <div className='pure-u-4-5'>
                                  <input className={`pure-input-1 ${ errors.amount && touched.amount
                                                ? "is-invalid":""}`}
                                              id="amount"
                                              type="number"
                                              name="amount"
                                              onChange={handleChange('amount')}
                                              onBlur={handleBlur('amount')}
                                              value={values.amount ?? ''}
                                              placeholder={ 'Montant' ?? '' } />  
                                              { errors.amount  && 
                                        <div id="validationServer05Feedback" className="invalid-feedback">
                                            { errors.amount  }
                                        </div> }
                              </div> 
                          </div>
                              
                        </div>
                       <div className='pure-u-1-5 pure-u-md-1-5'> 
                          <Field as="select"  
                            className={`  ${ errors.currency ? "is-invalid" : "" }`}
                                                                id="currency" 
                                                                name="currency"
                                                                onChange={(event: any) => {
                                                                    // console.log(event);
                                                                    handleChange('currency')(event);
                                                                    // const agent = getAgentById(event.target.value);
                                                                    // console.log(agent);
                                                                    // setSelectedAgent( agent );
                                                                }}
                                                                onBlur={handleBlur('currency')}
                                                                value={ values.currency }
                                                                placeholder="currency" >
                                                                {
                                                                    currencies.map(
                                                                        (currency: any, id) => <option 
                                                                         key={id} value={currency}>
                                                                            {
                                                                              currency
                                                                            }
                                                                        </option>
                                                                    )
                                                                }
                                                            </Field>   
                            </div>
                         </div>

                         </fieldset>
                         
                         <div style={{ marginBottom: 40 }} >
                          <div >
                              <div className='pure-g'>
                                  {
                                    definedAmounts.map(
                                      amount => <button onClick={() => {  
                                          console.log(amount);
                                          if (formRef.current !== null) {
                                                console.log("Setting amount"); 
                                                formRef.current.values.amount = amount;
                                                formRef.current.setTouched({amount: true});
                                                if (amount === null) {
                                                  formRef.current.setErrors({amount: 'required'})
                                                }
                                                setCurrentAmount( amount );
                                          
                                          }
                                        }}  className='pure-u-1-4 pure-button'  type='button' >

                                        <div  className={`amount-selector ${ values.amount === amount ? 'active' : '' } `}  >

                                            <div className={`amount-value ${ values.amount === amount ? 'active' : '' } `} >
                                            { amount !== null ? <><h5 style={{ display: 'inline-block'}} > 
                                               {numberWithCommas(amount)}  </h5> 
                                              <span className={`currency ${ values.amount === amount ? 'active' : '' } `} >
                                                {values.currency }
                                              </span> </> : 
                                              <p> Montant <br /> personnalisé </p>
                                              }
                                            </div>
                                          
                                        </div>
    
                                      </button>
                                    )
                                  }
                                 
                                   
                              </div>
                         </div>
                        </div>
  
                           
                        <div className="pure-g"> 
                                    <div className="pure-u-1"> 
                                      
                                            <button style={{ float: 'left' }} type="button"
                                                onClick={() => { previousStep() } }
                                                className="pure-button ">
                                                { 'Retour' }
                                            </button>

                                            <button style={{ float: 'right' }}  disabled={ !isValid }
                                             type="submit" 
                                              className="pure-button btn-validate">
                                                { 'Valider' } 
                                            </button> 
                                    </div>
                        </div>

                    </Form>
                )}
        </Formik>
       
  </div>
  );
};

const Step3 = () => {
  const {
    isLoading,
    isLastStep,
    isFirstStep,
    activeStep,
    stepCount,
    previousStep,
    nextStep,
    goToStep,
    handleStep,
  } = useWizard();

  const mobilePaymentFormRef = useRef< FormikProps< DonationMobilePaymentForm >>(null);
  const cardPaymentFormRef = useRef< FormikProps< DonationCardPaymentForm >>(null);

  let [
    activeKey, setActiveKey
   ] = useState('mobile');

   let [
    donationModal, setDonationModal
   ] = useState(false);

   let [
    donationUrl, setDonationUrl
   ]  = useState('');

   let [
    loading, setLoading
   ] = useState(false);

   let customerCountryInit: any = null;
   let [
    customerCountry, setCustomerCountry
   ]  = useState(customerCountryInit);

   const country_phone_code_init: string = ''; 

    const [
        countryPhoneCode, setCountryPhoneCode
    ] = useState(country_phone_code_init);

  // This handler is optional
  handleStep(() => {
    // alert('Going to step 2');
  });

  const handleSelect = (key: any) => { 
    setActiveKey(key); 
  }

  useEffect(
    () => { 
      donationData.method = activeKey;
    }, [activeKey]
  )

  // useEffect(
  //   () => { 
  //     if (mobilePaymentFormRef.current !== null) {
  //       const countrySelected: any = countries.all.filter((c:any, index: number) => c.alpha2 ===  mobilePaymentFormRef.current?.values.customer_country);
        
  //       if (countrySelected.length > 0) {
  //       mobilePaymentFormRef.current.values.customer_phone_id = countrySelected[0].countryCallingCodes[0];
  //       setCustomerCountry(countrySelected);
  //      }
        
  //     }
      
  //   }, [ mobilePaymentFormRef.current?.values ]
  // )

  return (
    <div className='wrapper'>
       <h2 className='stepTitle'> Soutenez notre cause </h2>
       <div className="seperator"></div>
        <br/>
        <Formik
                initialValues={
                    { customer_name: '', 
                        customer_email: '',
                        customer_phone_number:'', customer_country: ''  }}
                validationSchema={
                    yup.object().shape({
                        customer_name:  yup
                          .string()
                          .required('Ce champ est obligatoire'),
                        customer_email:  yup
                          .string()
                          .email('Email non correct')
                          .required('Ce champ est obligatoire'),
                        customer_phone_number:  yup
                          .string()
                          .required('Ce champ est obligatoire'),
                        customer_country:  yup
                          .string()
                          .required('Ce champ est obligatoire')
                      })
                }
                innerRef={ mobilePaymentFormRef }
                onSubmit={async (
                    values 
                ) => { 

                    setLoading(true);
                    await axiosInstance.post('/initialize_sainte_marthe_donation.php', {
                      ...donationData,
                      ...values,
                      customer_phone_number: countryPhoneCode + values.customer_phone_number
                    })
                    .then(async function (response: any) { 

                      console.log(response);
                      if (response.data.message === 'success') {
                        
                        setDonationUrl((value: any)  => response?.data?.response?.bill_url);

                        setTimeout(
                          () => {
                            console.log(donationUrl);
                            setDonationModal(true); 
                            setLoading(false);
                          }, 5000
                        );
                      } else if (response.data.message === 'error') {
                        alert("Une erreur s'est produite.");
                        setLoading(false);
                      } 
                       
                    })
                    .catch(function (error: any) {
                      console.log(error); 
                      setLoading(false);
                    });
                    
                    
          }}>
                {({ dirty, errors, touched, isValid, handleChange, handleBlur, handleSubmit, values }) => (
                    <Form className='pure-form'>

                    <fieldset>

                      <div className="pure-g"> 

                              <div className="pure-u-1"> 
                                      <label className='form-label'>
                                          {'Nom complet'} 
                                          <span style={{ color: 'red' }}> *</span>
                                      </label>  
                                      <div className='pure-u-1'>
                                        <input 
                                            className={`pure-input-1 ${ 
                                              errors.customer_name && touched.customer_name
                                              ? "is-invalid":""}`}
                                            id="customer_name"
                                            type="text"
                                            name="customer_name"
                                            onChange={handleChange('customer_name')}
                                            onBlur={handleBlur('customer_name')}
                                            value={values.customer_name ?? ''}
                                            placeholder={ 'Nom complet' ?? '' } />
                                        
                                      { errors.customer_name && touched.customer_name && errors.customer_name && 
                                      <div id="validationServer05Feedback" className="invalid-feedback">
                                          { errors.customer_name && touched.customer_name && errors.customer_name }
                                      </div> }
                                  </div>
                          </div>

                          <div className="pure-u-1"> 
                                      <label className='form-label'>
                                          {'Pays'}  
                                      </label>  
                                      <div className='pure-u-1' >
                                        <Field as="select" name="color" 
                                          className={`pure-input-1 ${ 
                                            errors.customer_phone_number && touched.customer_phone_number
                                            ? "is-invalid":""}`}
                                          id="customer_country"  
                                          onChange={(event: any) => {  
                                            handleChange('customer_country')(event);

                                            if (event.target.value !== '') { 
                                              console.log(event.target.value);
                                              const countrySelected: any = countries.all.filter((c:any, index: number) => c.alpha2 === event.target.value);
        
                                              if (countrySelected.length > 0) {
                                                   setCountryPhoneCode(countrySelected[0].countryCallingCodes[0]); 
                                                 
                                              } 

                                            }

                                          }}
                                          onBlur={handleBlur('customer_country')}
                                          value={values.customer_country ?? ''}
                                          placeholder={ 'Pays' ?? '' }>

                                          {
                                            countries !== null ? countries.all.map((c:any, index: number) => 
                                            <option  style={{ fontSize: "1em" }} key={index} 
                                            value={ c.alpha2  } 
                                            label={c.name}>
                                                {c.name}</option>)
                                            : <></>
                                          }

                                          {/* <option value="red">Red</option>
                                          <option value="green">Green</option>
                                          <option value="blue">Blue</option> */}

                                        </Field> 
                                        
                                      { errors.customer_country && touched.customer_country &&
                                       errors.customer_country && 
                                      <div id="validationServer05Feedback" className="invalid-feedback">
                                          { errors.customer_country && touched.customer_country &&
                                           errors.customer_country }
                                      </div> }
                                  </div>
                          </div>


                          <div className="pure-u-1"> 
                                      <label className='form-label'>
                                          {'Email'}  
                                      </label>  
                                      <div className='pure-1'>
                                        <input 
                                            className={`pure-input-1 ${ 
                                              errors.customer_email && touched.customer_email
                                              ? "is-invalid":""}`}
                                            id="customer_email"
                                            type="email"
                                            name="customer_email"
                                            onChange={handleChange('customer_email')}
                                            onBlur={handleBlur('customer_email')}
                                            value={values.customer_email ?? ''}
                                            placeholder={ 'Email' ?? '' } />
                                        
                                      { errors.customer_email && touched.customer_email && errors.customer_email && 
                                      <div id="validationServer05Feedback" className="invalid-feedback">
                                          { errors.customer_email && touched.customer_email && errors.customer_email }
                                      </div> }
                                  </div>
                          </div>




                          <div className="pure-u-1"> 
                                      <div className='pure-g'>
                                        <label className='form-label'>
                                            {'Téléphone'}  
                                        </label>  
                                      </div>  
                                      <div className='pure-g'>
                                        <div className="pure-u-1-8">
                                          <div style={{ backgroundColor: '#029ed7', color: 'white' }} className="input-group-text" >{ countryPhoneCode }</div>
                                        </div>
                                       <div className="pure-u-7-8">
                                            <input 
                                                  className={`pure-input-1 ${ 
                                                    errors.customer_phone_number && touched.customer_phone_number
                                                    ? "is-invalid":""}`}
                                                  id="phcustomer_phone_numberone"
                                                  type="text"
                                                  name="customer_phone_number"
                                                  onChange={handleChange('customer_phone_number')}
                                                  onBlur={handleBlur('customer_phone_number')}
                                                  value={values.customer_phone_number ?? ''}
                                                  placeholder={ 'Téléphone' ?? '' } />
                                              
                                            { errors.customer_phone_number && touched.customer_phone_number &&
                                            errors.customer_phone_number && 
                                            <div id="validationServer05Feedback" className="invalid-feedback">
                                                { errors.customer_phone_number && touched.customer_phone_number &&
                                                errors.customer_phone_number }
                                            </div> }
                                       </div>
                                  </div>
                          </div>
                                                  
                                    <div style={{marginTop: '50px' }} className="pure-u-1"> 
                                      
                                            <button style={{ float: 'left' }} type="button"
                                                onClick={() => { previousStep() } }
                                                className="pure-button ">
                                                { 'Retour' }
                                            </button> 

                                            <button  style={{ float: 'right' }}  disabled={ !isValid }
                                             type="submit" className="pure-button btn-validate">
                                                  {
                                                      loading && <i className="fas fa-spinner fa-spin"></i>
                                                  }
                                                { 'Faire un don' } 
                                            </button>  
                                    </div>
                                </div>
                                </fieldset>
                            </Form>
                        )}
                        
                </Formik>
        {/* <Tabs style={{  }} 
                                    onSelect={handleSelect}
                                    defaultActiveKey='mobile' 
                                    activeKey={activeKey} id="uncontrolled-tab-example">
            <Tab eventKey="mobile" title="Mobile money">


            

            </Tab>
            <Tab eventKey="card" title="Carte de crédit">

            <Formik
                initialValues={
                    { customer_name: '', 
                        customer_surname: '',
                        customer_email: '',
                        customer_phone_number:'',
                        customer_address: '',
                        customer_country: '',
                        customer_city: '',
                        customer_state: '',
                        customer_zip_code: '' }}
                validationSchema={
                    yup.object().shape({
                        customer_name:  yup
                          .string()
                          .required('Ce champ est obligatoire'),
                        customer_surname:  yup
                          .string()
                          .required('Ce champ est obligatoire'),
                        customer_email:  yup
                          .string()
                          .email('Email non correct'),
                        customer_phone_number:  yup
                          .string()
                          .required('Ce champ est obligatoire'),
                        customer_address: yup
                          .string()
                          .required('Ce champ est obligatoire'),
                        customer_country:yup
                          .string()
                          .required('Ce champ est obligatoire'),
                        customer_city: yup
                          .string()
                          .required('Ce champ est obligatoire'),
                        customer_state: yup
                          .string()
                          .required('Ce champ est obligatoire'),
                        customer_zip_code: yup
                          .string() 
                    })
                }
                innerRef={ cardPaymentFormRef }
                onSubmit={async (
                    values 
                ) => {

                    setLoading(true);
                    await axiosInstance.post('/initialize_sainte_marthe_donation.php', {
                      ...donationData,
                      ...values,
                      customer_phone_number: countryPhoneCode + values.customer_phone_number
                    })
                    .then(async function (response: any) { 
                      console.log(response);
                      if (response.data.message === 'success') {
                        setDonationUrl( (value: any)  => response?.data?.response?.bill_url);
                        setDonationModal(true);
                      } else if (response.data.message === 'error') {
                        alert("Une erreur s'est produite.");
                      } 
                      setLoading(false); 
                    }).catch(function (error: any) {
                      console.log(error); 
                      setLoading(false);
                    });
                    
                    
                }}>
                {({ dirty, errors, touched, isValid, handleChange, handleBlur, handleSubmit, values }) => (
                    <Form className='row'>

                      <div className="form-body col-md-12"> 

                       <div className="form-group"> 
                                      <label className='dorm-form-label'>
                                          {'Nom'} 
                                          <span style={{ color: 'red' }}> *</span>
                                      </label>  
                                      <div className='input-group'>
                                        <input 
                                            className={`form-control ${ 
                                              errors.customer_name && touched.customer_name
                                              ? "is-invalid":""}`}
                                            id="customer_name"
                                            type="text"
                                            name="customer_name"
                                            onChange={handleChange('customer_name')}
                                            onBlur={handleBlur('customer_name')}
                                            value={values.customer_name ?? ''}
                                            placeholder={ 'Nom' ?? '' } />
                                        
                                      { errors.customer_name && touched.customer_name && errors.customer_name && 
                                      <div id="validationServer05Feedback" className="invalid-feedback">
                                          { errors.customer_name && touched.customer_name && errors.customer_name }
                                      </div> }
                                  </div>
                          </div>


                          <div className="form-group"> 
                                      <label className='dorm-form-label'>
                                          {'Prénoms'} 
                                          <span style={{ color: 'red' }}> *</span>
                                      </label>  
                                      <div className='input-group'>
                                        <input 
                                            className={`form-control ${ 
                                              errors.customer_surname && touched.customer_surname
                                              ? "is-invalid":""}`}
                                            id="customer_surname"
                                            type="text"
                                            name="customer_surname"
                                            onChange={handleChange('customer_surname')}
                                            onBlur={handleBlur('customer_surname')}
                                            value={values.customer_surname ?? ''}
                                            placeholder={ 'Prénoms' ?? '' } />
                                        
                                      { errors.customer_surname && touched.customer_surname && 
                                      errors.customer_surname && 
                                      <div id="validationServer05Feedback" className="invalid-feedback">
                                          { errors.customer_surname && touched.customer_surname &&
                                           errors.customer_surname }
                                      </div> }
                                  </div>
                          </div>


                          <div className="form-group"> 
                                      <label className='dorm-form-label'>
                                          {'Email'}  
                                      </label>  
                                      <div className='input-group'>
                                        <input 
                                            className={`form-control ${ 
                                              errors.customer_email && touched.customer_email
                                              ? "is-invalid":""}`}
                                            id="customer_email"
                                            type="email"
                                            name="customer_email"
                                            onChange={handleChange('customer_email')}
                                            onBlur={handleBlur('customer_email')}
                                            value={values.customer_email ?? ''}
                                            placeholder={ 'Email' ?? '' } />
                                        
                                      { errors.customer_email && touched.customer_email && errors.customer_email && 
                                      <div id="validationServer05Feedback" className="invalid-feedback">
                                          { errors.customer_email && touched.customer_email && errors.customer_email }
                                      </div> }
                                  </div>
                          </div> 

                          <div className="form-group"> 
                                      <label className='dorm-form-label'>
                                          {'Pays'}  
                                      </label>  
                                      <div className='input-group' >
                                        <Field as="select" name="color" 
                                          className={`form-control ${ 
                                            errors.customer_country && touched.customer_country
                                            ? "is-invalid":""}`}
                                          id="customer_country"  
                                          onChange={(event: any) => {  
                                            handleChange('customer_country')(event);

                                            if (event.target.value !== '') { 
                                              console.log(event.target.value);
                                              const countrySelected: any = countries.all.filter((c:any, index: number) => c.alpha2 === event.target.value);
        
                                              if (countrySelected.length > 0) {
                                                   setCountryPhoneCode(countrySelected[0].countryCallingCodes[0]); 
                                                 
                                              } 

                                            }

                                          }}
                                          onBlur={handleBlur('customer_country')}
                                          value={values.customer_country ?? ''}
                                          placeholder={ 'Pays' ?? '' }>

                                          {
                                            countries !== null ? countries.all.map((c:any, index: number) => 
                                            <option  style={{ fontSize: "1em" }} key={index} 
                                            value={ c.alpha2  } 
                                            label={c.name}>
                                                {c.name}</option>)
                                            : <></>
                                          }

                                      

                                        </Field> 
                                        
                                      { errors.customer_country && touched.customer_country &&
                                       errors.customer_country && 
                                      <div id="validationServer05Feedback" className="invalid-feedback">
                                          { errors.customer_country && touched.customer_country &&
                                           errors.customer_country }
                                      </div> }
                                  </div>
                          </div>


                          <div className="form-group"> 
                                      <label className='dorm-form-label'>
                                          {'Région'}  
                                      </label>  
                                      <div className='input-group'>
                                        <input 
                                            className={`form-control ${ 
                                              errors.customer_state && touched.customer_state
                                              ? "is-invalid":""}`}
                                            id="customer_state"
                                            type="text"
                                            name="customer_state"
                                            onChange={handleChange('customer_state')}
                                            onBlur={handleBlur('customer_state')}
                                            value={values.customer_state ?? ''}
                                            placeholder={ 'Région' ?? '' } />
                                        
                                      { errors.customer_state && touched.customer_state &&
                                       errors.customer_state && 
                                      <div id="validationServer05Feedback" className="invalid-feedback">
                                          { errors.customer_state && touched.customer_state &&
                                           errors.customer_state }
                                      </div> }
                                  </div>
                          </div>

                          <div className="form-group"> 
                                      <label className='dorm-form-label'>
                                          {'Ville'}  
                                      </label>  
                                      <div className='input-group'>
                                        <input 
                                            className={`form-control ${ 
                                              errors.customer_city && touched.customer_city
                                              ? "is-invalid":""}`}
                                            id="customer_city"
                                            type="text"
                                            name="customer_city"
                                            onChange={handleChange('customer_city')}
                                            onBlur={handleBlur('customer_city')}
                                            value={values.customer_city ?? ''}
                                            placeholder={ 'Ville' ?? '' } />
                                        
                                      { errors.customer_city && touched.customer_city &&
                                       errors.customer_city && 
                                      <div id="validationServer05Feedback" className="invalid-feedback">
                                          { errors.customer_city && touched.customer_city &&
                                           errors.customer_city }
                                      </div> }
                                  </div>
                          </div>

                          <div className="form-group"> 
                                      <label className='dorm-form-label'>
                                          {'Téléphone'}  
                                      </label>  
                                      <div className='input-group'>
                                        <div className="input-group-prepend">
                                          <div className="input-group-text" >{ countryPhoneCode }</div>
                                        </div>
                                        <input 
                                            className={`form-control ${ 
                                              errors.customer_phone_number && touched.customer_phone_number
                                              ? "is-invalid":""}`}
                                            id="phcustomer_phone_numberone"
                                            type="text"
                                            name="customer_phone_number"
                                            onChange={handleChange('customer_phone_number')}
                                            onBlur={handleBlur('customer_phone_number')}
                                            value={values.customer_phone_number ?? ''}
                                            placeholder={ 'Téléphone' ?? '' } />
                                        
                                      { errors.customer_phone_number && touched.customer_phone_number &&
                                       errors.customer_phone_number && 
                                      <div id="validationServer05Feedback" className="invalid-feedback">
                                          { errors.customer_phone_number && touched.customer_phone_number &&
                                           errors.customer_phone_number }
                                      </div> }
                                  </div>
                          </div>


                          <div className="form-group"> 
                                      <label className='dorm-form-label'>
                                          {'Adresse'}  
                                      </label>  
                                      <div className='input-group'>
                                        <input 
                                            className={`form-control ${ 
                                              errors.customer_address && touched.customer_address
                                              ? "is-invalid":""}`}
                                            id="customer_address"
                                            type="text"
                                            name="customer_address"
                                            onChange={handleChange('customer_address')}
                                            onBlur={handleBlur('customer_address')}
                                            value={values.customer_address ?? ''}
                                            placeholder={ 'Adresse' ?? '' } />
                                        
                                      { errors.customer_address && touched.customer_address &&
                                       errors.customer_address && 
                                      <div id="validationServer05Feedback" className="invalid-feedback">
                                          { errors.customer_address && touched.customer_address &&
                                           errors.customer_address }
                                      </div> }
                                  </div>
                          </div>

                          <div className="form-group"> 
                                      <label className='dorm-form-label'>
                                          {'Code postale'}  
                                      </label>  
                                      <div className='input-group'>
                                        <input 
                                            className={`form-control ${ 
                                              errors.customer_zip_code && touched.customer_zip_code
                                              ? "is-invalid":""}`}
                                            id="customer_zip_code"
                                            type="text"
                                            name="customer_zip_code"
                                            onChange={handleChange('customer_zip_code')}
                                            onBlur={handleBlur('customer_zip_code')}
                                            value={values.customer_zip_code ?? ''}
                                            placeholder={ 'Code postale' ?? '' } />
                                        
                                      { errors.customer_zip_code && touched.customer_zip_code &&
                                       errors.customer_zip_code && 
                                      <div id="validationServer05Feedback" className="invalid-feedback">
                                          { errors.customer_zip_code && touched.customer_zip_code &&
                                           errors.customer_zip_code }
                                      </div> }
                                  </div>
                          </div>

                          <div className="form-actions col-md-12">
                                        <div className="text-right">
                                            
                                            <button style={{ float: 'left' }} type="button"
                                            onClick={() => { previousStep() } }
                                            className="btn btn-dark">
                                                { 'Retour' }
                                            </button>

                                            <button  disabled={!dirty && !isValid } type="submit" 
                                                className="btn btn-lg btn-validate">
                                                  {
                                    loading && <i className="fas fa-spinner fa-spin"></i>
                                 }
                                                { 'Faire un don' } 
                                            </button>  

                                        </div>
                                    </div> 
                                </div>
                            </Form>
                        )}
                </Formik> 

            </Tab>
        </Tabs> */}

        <Modal 
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                show={ donationModal }
                animation={false}
                
                onHide={() => {
                  setDonationModal(false);
                  window?.location?.reload();
                }}
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        { 'Faire un don' }
                    </Modal.Title> 
                </Modal.Header>
                <Modal.Body>
                  <iframe style={{ border: 'none' }} src={donationUrl}  height="500px" width="100%" ></iframe>
                </Modal.Body>
                <Modal.Footer>
                {/* <Button onClick={props.onHide}>Close</Button> */}
                </Modal.Footer>
            </Modal>
    </div>
  );
};

const Index: FC = () => {  
    
    return (
        <>      

            <Wizard 
                startIndex={0}
                header={<Header />}
                footer={<Footer />}
                // wrapper={<Wrapper />}
                >
                <Step1 />
                <Step2 />
                <Step3 />
            </Wizard>

            
        </>
    );
}

export default Index

